@if (iconStyleResolved === 'fontawesome') {
    @if (value) {
        <fa-icon [icon]="faCheck"></fa-icon>
    } @else {
        <fa-icon [icon]="faMinus" style="color: #bdbdbd"></fa-icon>
    }
} @else {
    @if (value) {
        <i class="bi bi-check2" style="color: var(--bs-green)"></i>
    } @else {
        <i class="bi bi-dash" style="color: #bdbdbd"></i>
    }
}
